import AllInvestmentsWidget from './AllInvestmentsWidget'

export default AllInvestmentsWidget
